/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FILE_TYPE_CONFIG } from './file-type';

// Get file information
export const getFileInfo = (file: File) => {
  const fileInfo = FILE_TYPE_CONFIG.find(({ judge, accept }) =>
    judge ? judge(file) : accept.some(ext => file.name.endsWith(ext)),
  );
  if (!fileInfo) {
    return null;
  }
  return fileInfo;
};
